import {useStoreSelector} from "./redux/useStoreSelector";
import {useCallback, useEffect} from "react";
import {dispatcher} from "../store";
import {useProfile} from "./useProfile";
import {useApi} from "./useApi";
import {useFetching} from "./system/useFetching";
import {useNotify} from "./system/useNotify";


export function useDeposit(clientId?: number) {
  const {client} = useProfile(),
    {api, isAuth} = useApi(),
    {withFetching} = useFetching(),
    {addNotify, handleApiError} = useNotify(),
    deposits = useStoreSelector( s => s.user.deposits)

  const loadDeposits = useCallback(async (clientId?: number) => {
    if (isAuth) {
      if (clientId) {
        try {
          const res = await withFetching(api.getClientsByIdDepositAddresses({id: clientId}))
          const body = handleApiError(res)
          if (body) {
            body.forEach(deposit_address => {
              if (deposit_address['assetName']) {
                deposit_address['assetName'] = deposit_address['assetName'].replace('C:S:', '')
              }
            })
            dispatcher.user.setDeposits(body)
          }
        } catch (e) {
          addNotify('error', 'Error', e.message)
        }
      } else if (client && client.id) {
        try {
          const res = await withFetching(api.getClientsByIdDepositAddresses({id: client.id}))
          const body = handleApiError(res)
          if (body) {
            body.forEach(deposit_address => {
              if (deposit_address['assetName']) {
                deposit_address['assetName'] = deposit_address['assetName'].replace('C:S:', '')
              }
            })
            dispatcher.user.setDeposits(body)
          }
        } catch (e) {
          addNotify('error', 'Error', e.message)
        }
      }
    } else {
      try {
        dispatcher.user.setDeposits([])
      } catch (e) {
        addNotify('error', 'Error', e.message)
      }
    }
  }, [addNotify, api, client, handleApiError, isAuth, withFetching])

  useEffect(() => {
    loadDeposits(clientId)
  }, [loadDeposits, clientId])

  return {deposits, loadDeposits}
}
